import { FC } from 'react';
import { FormProps } from '../helpers';
import OnOffToggleButton from '../on-off-toggle-button';
import { actionToToggleValue, toggleValueToAction } from './helpers';

interface Props extends FormProps {
  value?: 'read' | 'read-write';
  onChange: (action: 'read' | 'read-write' | undefined) => void;
}

const McpToolActionSwitch: FC<Props> = ({ value, onChange, ...rest }) => {
  const handleChange = (toggleValue: undefined | false | true) => {
    onChange(toggleValueToAction(toggleValue));
  };

  return (
    <OnOffToggleButton
      {...rest}
      value={actionToToggleValue(value)}
      onChange={handleChange}
    />
  );
};

export default McpToolActionSwitch;
